const getEmptyEvalLength = (): number => {
    // eslint-disable-next-line no-eval
    return eval.toString().length
}

export default getEmptyEvalLength;